import axios from 'axios';
import { LayoutPostData } from '../../data/shareLayout';
import { LinkPostData } from '../../data/share';
import * as Selectors from '../../store/selectors';
import { useAsync } from './useAsync';
import { useSelector } from '../hooks/redux';
import { ConfigurationPostData } from '../../data/shareConfiguration';

export function useSharingLinkAsync(
    currentUrl: string,
    ar: boolean,
    postData?: LayoutPostData | ConfigurationPostData,
) {
    const shortLinkServiceUrl = useSelector(Selectors.Core.shortLinkServiceUrl);
    const shortLinkFrontendUrl = useSelector(Selectors.Core.shortLinkFrontendUrl);
    const layoutUrl = useSelector(Selectors.Core.layoutUrl);
    const tenantIdentifier = useSelector(Selectors.Core.tenantIdentifier);

    const sharingUrlRequest = useAsync(async () => {
        if (
            shortLinkServiceUrl === undefined ||
            layoutUrl === undefined ||
            postData === undefined
        ) {
            return Promise.resolve(undefined);
        }

        const isConfigurationPostData =
            (postData as ConfigurationPostData).configuratorId !== undefined;

        const endpoint = isConfigurationPostData ? 'configurations' : 'layouts';
        const type = isConfigurationPostData
            ? `configuration${ar ? '-ar' : ''}`
            : `layout${ar ? '-ar' : ''}`;

        const responseDocument = await axios.post(
            `${layoutUrl}/api/v1/${tenantIdentifier}/${endpoint}`,
            JSON.parse(JSON.stringify(postData)),
        );

        const linkData: LinkPostData = {
            type,
            baseRedirectUrl: currentUrl,
            data: responseDocument.data,
        };

        const linkResponse = await axios.post(
            `${shortLinkServiceUrl}/api/v1/${tenantIdentifier}/links`,
            JSON.parse(JSON.stringify(linkData)),
        );

        return `${shortLinkFrontendUrl}/${linkResponse.data.linkId}`;
    }, [shortLinkServiceUrl, layoutUrl, postData, ar]);

    return sharingUrlRequest;
}
